import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { milestoneAcceptWork } from "../../../../../api-services/projects/milestones";
import {
  FEEDBACK_TYPE,
  feedbackMessage,
} from "../../../../professional/job-requests/hooks/feedbackErrors";
import { useToast } from "../../../../utils/useToast";

export const useMilestoneAcceptWork = (projectId?: string) => {
  const { projectId: paramsProjectId } = useParams();
  const { notifySuccess } = useToast();

  return useMutation(
    (milestoneId: string) =>
      milestoneAcceptWork(projectId ?? paramsProjectId, milestoneId),
    {
      onSuccess() {
        notifySuccess(feedbackMessage("milestone work", FEEDBACK_TYPE.ACCEPT));
      },
    }
  );
};
